module.exports = __webpack_public_path__ + "static/media/id-card-alt.f0790cc7.svg";